import { render, staticRenderFns } from "./GameSearch.vue?vue&type=template&id=5cac3b8a&scoped=true&"
import script from "./GameSearch.vue?vue&type=script&lang=js&"
export * from "./GameSearch.vue?vue&type=script&lang=js&"
import style0 from "./GameSearch.vue?vue&type=style&index=0&id=5cac3b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac3b8a",
  null
  
)

export default component.exports